import find from 'lodash/find'
import type { SelectOption } from '@ztechapps/webui.input'
import type { SpreadsheetCellSelectMode } from '@ztechapps/webui.data-tools'
import { Select } from '@ztechapps/webui.input'
import { angleUnit, lengthUnit, weightUnit } from '@ztechapps/common.utils'
import { MetadataSchemaInputEnum } from '@ztechapps/common.contract'
import { SPREADSHEET_CELL_MENU_PROPS, SpreadsheetCellSelect } from '@ztechapps/webui.data-tools'
import { useMetadataContext } from './Context'

export const allProductsSpecificationUnits = [...lengthUnit, ...weightUnit, ...angleUnit]

const UNIT_OPTIONS_BY_INPUT: Record<string, SelectOption[]> = {
  [MetadataSchemaInputEnum.LengthInput]: lengthUnit,
  [MetadataSchemaInputEnum.WeightInput]: weightUnit,
  [MetadataSchemaInputEnum.AngleInput]: angleUnit,
}

export type UnitSelectProps = {
  value?: string
  onChange?: (selected: SelectOption) => void
  inputName?: string
  spreadsheetMode?: SpreadsheetCellSelectMode
}

export const UnitSelect = ({ value, onChange, inputName, spreadsheetMode }: UnitSelectProps) => {
  const { hasRole } = useMetadataContext()
  // Resolved during render so the selected option is an element of `options` at mount — the
  // in-cell menu then highlights the current unit instead of the first option. The lookup stays
  // over the full list so a unit stored under another input still resolves.
  const selectedOption = find(allProductsSpecificationUnits, (item) => item.value === value) ?? null
  const options = UNIT_OPTIONS_BY_INPUT[inputName ?? ''] ?? allProductsSpecificationUnits

  const sharedProps = {
    disabled: !hasRole,
    placeholder: 'Select unit',
    value: selectedOption,
    options,
    onChange: (selected: SelectOption) => {
      onChange?.(selected)
    },
    ...SPREADSHEET_CELL_MENU_PROPS,
  }

  if (spreadsheetMode) {
    return (
      <SpreadsheetCellSelect
        {...sharedProps}
        onMenuStateChange={spreadsheetMode.onMenuStateChange}
        onCommit={spreadsheetMode.onCommit}
        defaultMenuIsOpen={spreadsheetMode.defaultMenuIsOpen}
        defaultInputValue={spreadsheetMode.defaultInputValue}
      />
    )
  }

  return (
    <div onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
      <Select {...sharedProps} />
    </div>
  )
}
